import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Flex } from 'components/ui';
import Chiclet from 'components/Chiclet';
import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';

const SimilarProductFilters = ({ featuresData, selectedVariation, onFilterChange, currentPrice }) => {
    if (!featuresData?.length) {
        return null;
    }

    const processFeatureValue = value => {
        if (value && typeof value === 'string' && value.includes('-insert-price-here-')) {
            return currentPrice ? value.replace('-insert-price-here-', currentPrice) : value;
        }

        return value;
    };

    const onChicletClick = ({ key, value }) => {
        const processedValue = processFeatureValue(value);

        onFilterChange(key);
        processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
            data: {
                linkData: `similar products:chiclet:${processedValue?.toLowerCase()}`
            }
        });
    };

    return (
        <Flex
            gap={2}
            marginBottom={4}
            paddingY={1}
            marginX='-container'
            paddingLeft={4}
            paddingRight={4}
            css={{
                overflow: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'none',
                overscrollBehaviorX: 'none',
                WebkitOverflowScrolling: 'touch',
                '&::-webkit-scrollbar': { display: 'none' }
            }}
        >
            {featuresData
                .filter(feature => {
                    if (!feature.key || !feature.value) {
                        return false;
                    }

                    // Hide chiclets with price placeholder if currentPrice is not available
                    if (feature.value.includes('-insert-price-here-') && !currentPrice) {
                        return false;
                    }

                    return true;
                })
                .map(feature => (
                    <Chiclet
                        key={feature.key}
                        variant='shadow'
                        isActive={selectedVariation === feature.key}
                        onClick={() => onChicletClick(feature)}
                        children={processFeatureValue(feature.value)}
                        css={{
                            flexShrink: 0,
                            whiteSpace: 'nowrap',
                            width: 'auto'
                        }}
                    />
                ))}
        </Flex>
    );
};

SimilarProductFilters.propTypes = {
    featuresData: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            value: PropTypes.string
        })
    ),
    selectedVariation: PropTypes.string,
    onFilterChange: PropTypes.func.isRequired,
    currentPrice: PropTypes.string
};

export default wrapFunctionalComponent(SimilarProductFilters, 'SimilarProductFilters');
